import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'PUT_PROCESS',
    method: 'PUT',
    data: param,
  });

  useEffect(() => {
    if (param && param.id) {
      let url = `/api/system/processes/${param.id}`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);
  return { exec, isRequestSuccessed };
});
